// extracted by mini-css-extract-plugin
export default {"paginContainer":"Paginated_paginContainer__Sozjb"};